export const injectPolyfills = async () => {
  // Remove when Safari 16.0, Chrome 106 and Firefox 110 is an acceptable minimum
  if (CSS && !CSS.supports('container-type', 'size')) {
    // biome-ignore lint/plugin: needed for panel bundling
    await import('container-query-polyfill' as string);
  }
};
